import { createSlice } from '@reduxjs/toolkit'

interface SelfExclusionState {
    data: any[]
    loading: boolean
}

const initialState: SelfExclusionState = {
    data: [],
    loading: false
}

const selfExclusionSlice = createSlice({
    name: 'selfExclusion',
    initialState: initialState,
    reducers: {
        setSelfExclusionData: (state, action) => {
            state.data = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        clearStates: () => initialState
    }
})

export const { setSelfExclusionData, setLoading, clearStates } = selfExclusionSlice.actions
export default selfExclusionSlice.reducer
